<template>
  <q-modal v-model="visible" content-css="{width: '500px'}">
    <div class="q-pa-md">
      <div class="item">
        <div class="heading">Имя</div>
        <div class="body">{{user.first_name}} {{user.last_name}}</div>
      </div>
      <div class="item">
        <div class="heading">Имейл</div>
        <div class="body">{{user.email}}</div>
      </div>
      <div class="item">
        <div class="heading">Телефон</div>
        <div class="body">{{user.phone_number}}</div>
      </div>
      <div class="item">
        <div class="heading">Баланс</div>
        <div class="body">{{user.account_amount}}</div>
      </div>
    </div>
  </q-modal>
</template>

<script>
  import {
    QModal
  } from 'quasar';

  export default {
    name: 'UserPreview',
    components: {
      QModal
    },
    props: {
      value: Boolean,
      user: Object
    },
    computed: {
      visible: {
        get () {
          return this.value;
        },
        set (val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/UserPreview/UserPreview.vue